import { gql } from '@apollo/client';

export const GET_VIEW = gql`
  query view($request: ViewRequest!) {
    view(request: $request) {
      viewMetadata {
        measure
        type
        link
        label
        format
      }
      entitiesResponse {
        name
        entities {
          id
          name
          icon
          url
          dataJson
        }
        totalPageCount
        totalRowCount
      }
    }
  }
`;
